/**
 * gamepad-dom — browser-side gamepad access shared by the controller hooks.
 * Guards for jsdom, where `navigator.getGamepads` does not exist.
 */

export type GetGamepads = () => (Gamepad | null)[]

export function defaultGetGamepads(): (Gamepad | null)[] {
  if (typeof navigator === 'undefined' || typeof navigator.getGamepads !== 'function') return []

  return navigator.getGamepads()
}

export function firstPad(pads: (Gamepad | null)[]): Gamepad | null {
  for (const pad of pads) {
    if (pad) return pad
  }

  return null
}
